import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetEmspUsersInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoInvoiceListContext } from '../../emsp-bo-invoice.context';
import { EmspBoInvoiceListFilterFormStep1Controller } from '../emsp-bo-invoice-list-filter-form-step-1/emsp-bo-invoice-list-filter-form-step-1.controller';

export interface EmspBoInvoiceListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetEmspUsersInvoicesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetEmspUsersInvoicesPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoInvoiceListFilterFormController = (
  props: EmspBoInvoiceListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterEmspBoInvoiceListContext();

  return (
    <MultiStepFormProvider<GetEmspUsersInvoicesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['status', 'type'],
          component: <EmspBoInvoiceListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
